import React from 'react';
import { Instagram, Phone } from 'lucide-react';
import { Watermark } from './Watermark';
export function Footer() {
  return <footer className="relative overflow-hidden bg-luxury-black text-white py-16 px-6 border-t border-gray-800" data-id="element-99" data-mp="3gg0zo4mhnzy6">
      <Watermark position="center" align="top" size={780} opacity={0.07} dark data-id="element-100" data-mp="32pp6e2e63v5g" />
      <div className="relative z-10 max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-101" data-mp="36q92d2n08sq0">
        <h2 className="text-2xl font-serif mb-2 tracking-wider" data-id="element-102" data-mp="3ug3c3bc12161">
          ALEXA BEAUTY
        </h2>
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-8" data-id="element-103" data-mp="37ft3219eq1n">
          Brows And Lashes
        </p>

        <p className="font-serif italic text-gray-400 mb-10 text-lg" data-id="element-104" data-mp="3ldu2qoshwdu8">
          Belleza profesional con estilo.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-center justify-center text-sm font-sans text-gray-300" data-id="element-105" data-mp="3qf9q4ni5awfs">
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-106" data-mp="2ey09e8qeiii6">
            <Instagram className="w-5 h-5" data-id="element-107" data-mp="3lalhzkmm4fwl" />
            @alexabeauty
          </a>
          <span className="hidden sm:block text-gray-600" data-id="element-108" data-mp="3gaz1n2bhmjjk">|</span>
          <a href="#" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-109" data-mp="3gctpaoe58prc">
            <Phone className="w-5 h-5" data-id="element-110" data-mp="3q83u1jvxfb8t" />
            +1 (555) 123-4567
          </a>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-800 w-full text-xs text-gray-500 font-sans" data-id="element-111" data-mp="82idvwen2ggf">
          &copy; {new Date().getFullYear()} Alexa Beauty. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}